import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

// The committed .env is shared by both the preview and the production (Cloudflare) builds,
// so REACT_APP_SENTRY_ENVIRONMENT can't differentiate them. Derive it from the host instead.
function resolveSentryEnvironment() {
    if (typeof window !== "undefined" && window.location && window.location.hostname) {
        const h = window.location.hostname;
        if (h === "app.qubeaccountants.co.uk") return "production"; // exact production host only
        if (h.endsWith(".preview.emergentagent.com") || h === "localhost" || h === "127.0.0.1") return "preview";
    }
    // Unknown host: never assume production — fall back to the build-time value (defaults to preview).
    return process.env.REACT_APP_SENTRY_ENVIRONMENT || "preview";
}

// Strip anything that could carry client/financial/PII/secret data.
const SENSITIVE = /(authoriz|cookie|token|secret|password|mongo|dsn|e-?mail|amount|balance|fee|debit|credit|private_key|ssn|account|iban|sort.?code|card)/i;

if (dsn) {
    try {
        Sentry.init({
            dsn,
            environment: resolveSentryEnvironment(),
            release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
            tracesSampleRate: 0.0, // performance tracing OFF
            // profiling + session replay intentionally NOT added
            sendDefaultPii: false,
            maxBreadcrumbs: 20,
            beforeSend(event) {
                try {
                    if (event.request) delete event.request; // url/query/headers/cookies/body
                    delete event.user;
                    for (const sect of ["extra", "tags", "contexts"]) {
                        const d = event[sect];
                        if (d && typeof d === "object") {
                            for (const k of Object.keys(d)) if (SENSITIVE.test(k)) d[k] = "[redacted]";
                        }
                    }
                } catch (e) { /* never block error reporting */ }
                return event;
            },
            beforeBreadcrumb(crumb) {
                if (crumb.category === "console") return null; // may contain logged data
                if (crumb.data && typeof crumb.data === "object") {
                    for (const k of Object.keys(crumb.data)) {
                        if (SENSITIVE.test(k) || ["body", "request_body", "response_body"].includes(k)) delete crumb.data[k];
                    }
                }
                return crumb;
            },
        });
    } catch (e) {
        // monitoring must never break the app
        // eslint-disable-next-line no-console
        console.error("Sentry init failed (continuing without it)", e);
    }
}
